// extracted by mini-css-extract-plugin
module.exports = {"action":"actionsColumn_action__ZGyVx"};